import React, { useState, useEffect } from 'react'
import { Background, LobbyCard } from '../Pages/styles'

interface LoadingIndicatorProps {
    message?: string
    showColdStartWarning?: boolean
    coldStartThreshold?: number
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
    message = "Loading",
    showColdStartWarning = true,
    coldStartThreshold = 5000
}) => {
    const [showColdStart, setShowColdStart] = useState(false)

    useEffect(() => {
        if (showColdStartWarning) {
            const timer = setTimeout(() => setShowColdStart(true), coldStartThreshold)
            return () => clearTimeout(timer)
        }
    }, [showColdStartWarning, coldStartThreshold])

    return (
        <Background>
            <LobbyCard>
                <div style={{
                    fontSize: "20px",
                    fontWeight: 600,
                    marginBottom: "20px",
                    color: "#60a5fa"
                }}>
                    {message}...
                </div>

                {/* Loading spinner */}
                <div style={{
                    width: "60px",
                    height: "60px",
                    border: "4px solid rgba(96, 165, 250, 0.2)",
                    borderTop: "4px solid #60a5fa",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite"
                }}>
                    <style>{`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}</style>
                </div>

                {showColdStart && (
                    <div style={{
                        marginTop: "30px",
                        padding: "16px 20px",
                        backgroundColor: "rgba(251, 191, 36, 0.2)",
                        border: "2px solid rgba(251, 191, 36, 0.5)",
                        borderRadius: "12px",
                        color: "#fbbf24",
                        fontSize: "16px",
                        fontWeight: 500,
                        lineHeight: "1.6",
                        maxWidth: "500px"
                    }}>
                        <div style={{ marginBottom: "8px", fontSize: "18px" }}>
                            ⏳ Server is waking up...
                        </div>
                        <div style={{ fontSize: "14px", opacity: 0.9 }}>
                            This app runs on a free tier that goes to sleep after inactivity.
                            It may take 30-60 seconds to start up. Thank you for your patience!
                        </div>
                    </div>
                )}
            </LobbyCard>
        </Background>
    )
}

export default LoadingIndicator
